import { Box, Flex, Link, Text, VStack } from '@chakra-ui/react';
import { StepTitle } from '../step-title';
import { NumberedStep } from '../numbered-step';

export const StartStreamingStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        <StepTitle stepNumber={7} title="Start Streaming With FrogBox Go" />

        {/* Instructions */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={2}>
            <NumberedStep number={1}>
              <Text as="span">
                Log into FrogBox Go at{' '}
                <Link
                  href="https://go.frogbox.live/login"
                  color="green.600"
                  fontWeight="semibold"
                  textDecoration="underline"
                  _hover={{ color: 'green.700' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  go.frogbox.live/login
                </Link>{' '}
                (if you don't have access, ask your club admin)
              </Text>
            </NumberedStep>
            <NumberedStep number={2}>
              <Text as="span">
                Find your match via{' '}
                <Text as="span" fontWeight="bold">
                  Today's Streams
                </Text>{' '}
                or{' '}
                <Text as="span" fontWeight="bold">
                  Manage Stream
                </Text>
              </Text>
            </NumberedStep>
            <NumberedStep number={3}>
              <Text as="span">
                Look for the ✓ under team names or{' '}
                <Text as="span" fontWeight="bold">
                  Service is Live
                </Text>{' '}
                at the top indicating FrogBox is ready to receive vision
              </Text>
            </NumberedStep>
            <NumberedStep number={4}>
              <Text as="span">
                Scroll down to{' '}
                <Text as="span" fontWeight="bold">
                  Preview Stream
                </Text>
              </Text>
            </NumberedStep>
            <NumberedStep number={5}>
              <Text as="span">
                Click{' '}
                <Text as="span" fontWeight="bold">
                  ▶ Play
                </Text>{' '}
                to view your live vision (note: Preview is available within 1
                hour before your stream starts)
              </Text>
            </NumberedStep>
            <NumberedStep number={6}>
              <Text as="span">
                Click{' '}
                <Text as="span" fontWeight="bold">
                  Diagnostics
                </Text>{' '}
                to troubleshoot issues as needed
              </Text>
            </NumberedStep>
          </VStack>
        </Box>

        {/* Screenshots */}
        <Box w="full" borderRadius="xl" overflow="hidden">
          <img
            src={`${import.meta.env.BASE_URL}images/start-streaming.webp`}
            alt="FrogBox Go streaming instructions"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>
      </VStack>
    </Flex>
  );
};
